import { Component, OnInit } from '@angular/core';
import { PublicNotesDiscussions } from 'src/app/_models';

@Component({
  selector: 'app-whatsapp-post',
  templateUrl: './whatsapp-post.component.html',
  styleUrls: ['./whatsapp-post.component.scss']
})
export class WhatsappPostComponent implements OnInit {
  activeNote: PublicNotesDiscussions = null;
  constructor() {}

  ngOnInit() {}
}
